window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';
import 'script-loader!node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'script-loader!node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { InitSoy2JS } from 'js/components/Soy2js/Soy2js.js';
InitSoy2JS(window.Yext);

import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { LocationHoursMod } from 'js/common/modules/LocationHoursMod.js';
import { Maps } from 'js/components/Maps/index.js';
import { LocationMap } from 'js/common/modules/LocationMap.js';

Yext.Maps = { LocationMap: LocationMap };
Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  LocationMap.initClass();
  Maps.loadAndRun();
  LocationHoursMod.loadAndRun();

  for (let section of document.querySelectorAll('[data-collapse-target]')) {
    section.addEventListener('click', _ => {
      let target = section.dataset.collapseTarget;
      let isDesktop = window.matchMedia("(min-width: 768px)").matches;
      let isAnimating = section.classList.contains('is-animating');
      if (!target || isDesktop || isAnimating) return;
      section.classList.toggle('js-is-compact');
      section.classList.add('is-animating');
      $(target).slideToggle(300, _ => {
        section.classList.remove('is-animating');
      });
    });
  }
});
